import { object } from 'yup';

const validationSchema = object({
  state: object()
    .nullable()
    .required('The State field is required')
    .default(null),
  district: object()
    .nullable()
    .required('The District field is required')
    .default(null),
});

export const getValidation = () => {
  return {
    validationSchema,
    defaultValues: validationSchema.cast({}),
  };
};
